<!--
 * @Description:市场营销-线索管理导入
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-08-27 15:09:38
 * @LastEditors: mdb
-->
<template>
  <div style="display: inline-block; margin-right: 10px">
    <a-button @click="visible = true">{{t('btn.import')}}</a-button>
    <a-modal v-model:visible="visible" :title="t('btn.import')" width="670px" :footer="null">
      <a-form :model="form" ref="formRef" v-if="visible">
        <a-form-item name="file" label="">
          <uploadFile v-bind="$attrs" :action="action" :templateUrl="templateUrl" @success="success" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import uploadFile from '@/components/ImportBtn/src/uploadFile.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const formRef = ref()
const visible = ref(false)
const form = ref<any>({})
const emit = defineEmits(['success'])
defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  action: {
    type: String, // 接口地址
    default: ''
  },
  templateUrl: {
    type: String,
    default: ''
  }
})
const toggle = () => {
  visible.value = !visible.value
}
const success = () => {
  visible.value = false
  emit('success')
}

defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'ImportBtn' }
</script>
<style lang="scss" scoped></style>
